import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Product Slider CVA Configuration
 *
 * Design tokens from tailwind.config.js:
 * - text-color (#1c1b21) - Main text color
 * - font-main-font (Poppins) - Heading font
 */

/**
 * Product slider section container
 */
export const productSliderSectionVariants = cva('homepage-product-slider mb-8')

export type ProductSliderSectionVariants = VariantProps<typeof productSliderSectionVariants>

/**
 * Product slider title - centered, larger for prominence
 */
export const productSliderTitleVariants = cva('text-3xl md:text-4xl font-bold text-text-color mb-8 text-center font-main-font')

export type ProductSliderTitleVariants = VariantProps<typeof productSliderTitleVariants>

/**
 * Product slider wrapper (contains swiper + navigation)
 */
export const productSliderWrapperVariants = cva('relative')

export type ProductSliderWrapperVariants = VariantProps<typeof productSliderWrapperVariants>

/**
 * Product slider Swiper container
 * py-3 adds vertical padding for card hover effects
 */
export const productSliderSwiperVariants = cva('product-slider-swiper py-3')

export type ProductSliderSwiperVariants = VariantProps<typeof productSliderSwiperVariants>

/**
 * Product slider slide — background + padding applied here so SwiperSlide uses pure CVA.
 */
export const productSliderSlideVariants = cva('!h-auto bg-cards-bg px-1 py-2')

export type ProductSliderSlideVariants = VariantProps<typeof productSliderSlideVariants>

/**
 * Product slider skeleton grid
 * Matches the responsive slidesPerView: 2 mobile, 3 tablet, 5 desktop
 */
export const productSliderSkeletonGridVariants = cva(
  'grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-2 py-3'
)

export type ProductSliderSkeletonGridVariants = VariantProps<typeof productSliderSkeletonGridVariants>

/**
 * Product slider grid mode container — same responsive shape as
 * productSliderSkeletonGridVariants and categoryCardsGridVariants.
 */
export const productSliderGridVariants = cva(
  'grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-0 bg-cards-bg p-1'
)
export type ProductSliderGridVariants = VariantProps<typeof productSliderGridVariants>

/**
 * Product slider grid item — wraps each ProductCard in grid mode.
 */
export const productSliderGridItemVariants = cva('bg-cards-bg px-1 py-2')
export type ProductSliderGridItemVariants = VariantProps<typeof productSliderGridItemVariants>
